import React, { useEffect, useState } from "react"
import { Link, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import Layout from "@components/Layout"
import { useWindowSize } from "@hooks"

const DonatePage = ({ data }) => {
  const [image, setImage] = useState(getImage(data.header))
  const [height, setHeight] = useState(700)
  const [mobile, setMobile] = useState(false)
  const size = useWindowSize()
  const { width } = size

  useEffect(() => {
    if (width <= 1100) {
      setImage(getImage(data.headerMobile))
      setHeight(400)
      setMobile(true)
    } else if (height === 400) {
      setImage(getImage(data.header))
      setHeight(700)
      setMobile(false)
    }
  }, [width, data.headerMobile, data.header])

  const logo = getImage(data.logo)
  const venmo = getImage(data.venmo)

  return (
    <Layout
      seoTitle="Donate"
      seoDescription="Bryan Smethurst for City Council"
      image={image}
      height={height}
      mobile={mobile}
    >
      <div
        className="cover-container"
        style={{ backgroundColor: "#141433", display: "block" }}
      >
        <div className="cover-inner">
          <div id="donation" className="cover-left-content">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="logo text-center">
                    <Link to="/">
                      <GatsbyImage image={logo} alt="Bryan Smethurst Logo" />
                    </Link>
                  </div>

                  <div className="box-wrapper" style={{ margin: "20px auto" }}>
                    <div
                      className="box accent-box"
                      style={{ backgroundColor: "#ffffff" }}
                    >
                      <h3 className="text-center" style={{ color: "#ba1c24" }}>
                        DONATE TO THE CAMPAIGN
                      </h3>
                      <GatsbyImage image={venmo} alt="Bryan Smethurst Venmo" />
                      <h3 className="text-center">
                        <a
                          href="https://venmo.com/Bryan-Smethurst-1"
                          target="_blank"
                        >
                          Bryan-Smethurst-1
                        </a>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row" style={{ marginTop: 20 }}>
                <div
                  className="col-md-6 text-center"
                  style={{ margin: "0 auto", float: "unset" }}
                >
                  <p>
                    If you would like other options to donate please email me at{" "}
                    <a
                      href="mailto:bryan@votebryansmethurst.com"
                      target="_blank"
                    >
                      bryan@votebryansmethurst.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query DonatePageQuery {
    header: file(relativePath: { eq: "Bryan_Smethurst_header_2402x1141.jpg" }) {
      childImageSharp {
        gatsbyImageData(
          width: 2402
          placeholder: BLURRED
          formats: [AUTO, WEBP, AVIF]
        )
      }
    }
    headerMobile: file(
      relativePath: { eq: "header_mobile_white_1200x956.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(
          width: 1200
          placeholder: BLURRED
          formats: [AUTO, WEBP, AVIF]
        )
      }
    }
    logo: file(relativePath: { eq: "logo-white.png" }) {
      childImageSharp {
        gatsbyImageData(
          width: 1000
          placeholder: BLURRED
          formats: [AUTO, WEBP, AVIF]
        )
      }
    }
    venmo: file(relativePath: { eq: "venmo_847x847.png" }) {
      childImageSharp {
        gatsbyImageData(
          width: 847
          placeholder: BLURRED
          formats: [AUTO, WEBP, AVIF]
        )
      }
    }
  }
`

export default DonatePage
